import React from 'react';
import { Box, Icons, Typography, useTheme } from '@ublend-npm/aulaui-core';
import { createStyles } from './CommonRoomResponsive.styles';

const ScheduledPostsResponsive = () => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Box sx={styles.feedLayout} data-testid="responsive-scheduled-layout">
      <Box component="header" sx={styles.scheduledHeader}>
        <Typography component="h2" variant="h6">
          Scheduled posts
        </Typography>
      </Box>

      <Box
        component="section"
        aria-label="Scheduled posts"
        sx={styles.postsRegion}
      >
        <Box sx={styles.postPlaceholderCard}>
          <Box sx={styles.placeholderHeader}>
            <Box sx={styles.placeholderIcon} aria-hidden="true">
              <Icons.Schedule fontSize="small" />
            </Box>
            <Box sx={styles.placeholderText}>
              <Typography component="h3" variant="subtitle1">
                Scheduled post
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Publishing date and time
              </Typography>
            </Box>
          </Box>

          <Typography variant="body2">
            Scheduled post content will render in this region.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ScheduledPostsResponsive;
